                                <!-- <mat-option *ngIf="isLoading" class="is-loading">
                                    <mat-spinner diameter="50"></mat-spinner>
                                </mat-option> -->

<div class="card" *ngIf="isDataLoaded">
    <div class="card-header card-header-squirrel">
        <h4>{{this.translate.data['ADDNEWPROJECT'] | translate}}</h4>        
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-12">
                HINWEIS: Zur Übernahme von bestehenden Gruppen, Benutzern und/oder Inhalten eines bereits bestehenden Projektes
                 verwenden Sie statt der Neuanlage bitte die Funktion "Kopieren" an dem bestehenden Projekt.            
                 <br><br>
            </div>
        </div>
        <form [formGroup]="projectCreationForm" novalidate *ngIf="isFormCreated">
            
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field class="example-full-width">
                        <input type="text" matInput placeholder="{{this.translate.data['PROJECTNAME'] | translate}}" formControlName="name" required>
                        <mat-error *ngIf="!projectCreationForm.controls['name'].valid && projectCreationForm.controls['name'].touched"> {{this.translate.data['ERRORALERT'] | translate}} </mat-error>
                    </mat-form-field>
                </div>
            </div> 
            <br>           
            <!-- <mat-slide-toggle 
                *ngIf="!isWPTenant" 
                [disabled]="false" 
                color="primary" 
                (change)="onChange($event)" 
                >
                <b>Projektvorlagen auswählen</b>
            </mat-slide-toggle>
            <br><br> -->

            <!-- <div class="row" *ngIf="isWPTenant" >
                <div class="col-md-4">
                    <mat-form-field class="example-full-width">
                        <input type="text" matInput placeholder="Winplan Mandant" formControlName="wpTenant" required>
                        <mat-error *ngIf="!projectCreationForm.controls['wpTenant'].valid && projectCreationForm.controls['wpTenant'].touched"> {{this.translate.data['ERRORALERT'] | translate}} </mat-error>
                    </mat-form-field>
                </div>
            </div>             -->
            <div class="row" *ngIf="isWPTenant" >
                <div class="col-md-4">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Winplan Projekt Id" formControlName="wpProjectId" required>
                        <mat-error *ngIf="!projectCreationForm.controls['wpProjectId'].valid && projectCreationForm.controls['wpProjectId'].touched"> {{this.translate.data['ERRORALERT'] | translate}} </mat-error>
                    </mat-form-field>
                </div>
            </div>           
            <div *ngIf="!isWPTenant && isTemplateForAdmin">
                <h5>Administrator des Projektes (E-Mail Adresse):</h5>
                <div class="row" style="margin-top: -20px;">
                    <div class="col-md-12">
                        <mat-form-field class="example-full-width" *ngIf="!_userSelected">
                            <input matInput placeholder="{{this.translate.data['SEARCHUSER'] | translate}}" formControlName="adminUser" [matAutocomplete]="auto" required>

                            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                                (optionSelected)="optionSelected($event)">
                                <!-- <mat-option *ngIf="isLoading" class="is-loading">
                                    <mat-spinner diameter="50"></mat-spinner>
                                </mat-option> -->
                                <ng-container *ngIf="!isLoading">
                                    <mat-option *ngFor="let user of users" [value]="user">
                                        <span><b>{{ user.userName }}</b> - {{ user.email }}</span>
                                    </mat-option>
                                </ng-container>
                            </mat-autocomplete>
                        </mat-form-field>
                        <a class="a-color" *ngIf="_userSelected && adminUserEmail != ''">{{adminUserEmail}}</a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Description" formControlName="description" >
                        <!-- <mat-error *ngIf="!projectCreationForm.controls['description'].valid && projectCreationForm.controls['description'].touched"> {{
                            this.translate.data['ERRORALERT'] | translate}}  </mat-error> -->
                    </mat-form-field>
                </div>
            </div>               
        </form>

        <div class="row">
            <div class="col-md-10">
                <mat-form-field class="example-full-width">
                    <mat-label>Server</mat-label>
                    <mat-select [(ngModel)]="selectedServer" required>
                        <mat-option *ngFor="let server of servers" [value]="server">
                            <span><b>{{ server }}</b></span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <!-- <div class="col-md-2">
                <span style="color: red; font-weight: 600"> {{migrationError}}</span>
            </div> -->
        </div>
        <div class="row">
            <a>
                <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                (click)="cancel()" >Abbruch</button>
            </a>                                                
            <span style="flex: 1 1 auto"></span>
            <a *ngIf="!isWPTenant">
                <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="Projektvorlagen auswählen"
                    (click)="selectUserPermission()"  [disabled]="!isFormValid()">Weiter
                </button>
                <!-- <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="{{this.translate.data['ADDNEWPROJECT'] | translate}}"
                    (click)="add()" >Hinzufügen
                </button> -->
            </a>                   
            <a *ngIf="isWPTenant">
                <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="{{this.translate.data['ADDNEWPROJECT'] | translate}}"
                    (click)="add()"  [disabled]="!isFormValid()">Projekt anlegen
                </button>
            </a>                   
        </div>    

    </div>
</div>